import { createContext } from 'react';

export const TestReviewModeContext = createContext({
  enabled: false,
  editMode: false,
  translationMode: false,
  translationSourceLocale: null,
  translationSourceMessages: null
});
